<template>
  <div class="rangeSelect pt-4">
    <div class="rangeSelect-wrp" :style="{ gridTemplateColumns: `repeat(${7}, 1fr)` }">
      <div
        v-for="(el, index) in optionsLength"
        :key="el.level"
        class="rangeSelect-el"
        :class="{
          level0: index === 3,
          levelBord1: index === 2,
          levelBord2: index === 4,
          redLevel1: reactionsLevel === -1 && index === 2,
          redLevel2: reactionsLevel === -2 && optionsLength[index].level < 3 && optionsLength[index].level !== 0,
          redLevel3: reactionsLevel === -3 && optionsLength[index].level < 3,
          greenLevel1: reactionsLevel === 1 && optionsLength[index].level === 4,
          greenLevel2: reactionsLevel === 2 && optionsLength[index].level >= 4 && index !== 6,
          greenLevel3: reactionsLevel === 3 && optionsLength[index].level >= 4,
        }"
        @click="handleSetValue(el.value, el.level)">
        <div class="rangeSelect-el-line" :class="`color-${Math.abs(el.value)}`"></div>
        <div
          class="rangeSelect-el-txt"
          :class="
            clsx(
              {
                selected: model >= Math.abs(el.value),
              },
              `color-${el.level}`,
            )
          ">
          {{ Math.abs(el.value) }}
        </div>
      </div>
    </div>

    <span class="rangeSelect-el-circle" :class="`color-${model}`" :style="{ left: positionBullet }"></span>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';

import clsx from 'clsx';

const level = ref(3);
const reactionsLevel = ref(0);
const model = defineModel();
const isRed = ref(false);
const positionBullet = computed(() => {
  if (level.value < 3) {
    isRed.value = true;
  } else {
    isRed.value = false;
  }

  // Move the slider (circle)
  if (level.value >= 0 && level.value < positionsBullet.length) {
    return positionsBullet[level.value] + '%';
  }
  return '0px';
});

function handleSetValue(value, position) {
  reactionsLevel.value = value;
  level.value = position;
  model.value = value;
}

const optionsLength = [
  { level: 0, value: -3 },
  { level: 1, value: -2 },
  { level: 2, value: -1 },
  { level: 3, value: 0 },
  { level: 4, value: 1 },
  { level: 5, value: 2 },
  { level: 6, value: 3 },
];
// Positions for the circle
const positionsBullet = [5.5, 19.1, 33.4, 47.9, 62, 76.4, 90.5];
</script>

<style scoped lang="scss">
.rangeSelect {
  position: relative;

  &-wrp {
    display: grid;
    width: 100%;
  }

  &.isRed {
    --color: #931919;
    --color_2: #b72020;
    --color_3: #dc2626;
    --borderSelected: #e24a4a;
    --colorHovered_1: #715353;
    --colorHovered_2: #835656;
  }

  &.isGreen {
    --color: #17833f;
    --color_2: #1ca44e;
    --color_3: #22c55e;
    --borderSelected: #035b21;
    --colorHovered_1: #526d5c;
    --colorHovered_2: #547660;
  }

  &.hasSelected {
    .rangeSelect-el-line {
      background: var(--colorHovered);
      border-color: var(--colorHovered);
      border-left-color: #959595;
    }
  }

  &:hover {
  }

  &-el {
    cursor: pointer;
    position: relative;
    &.level0 .rangeSelect-el-line {
      border: 2px solid #1d1d21;
      border-radius: 10px;
      height: 14px;
      margin-top: -2px;
    }
    &.levelBord1 .rangeSelect-el-line {
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
    }
    &.levelBord2 .rangeSelect-el-line {
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
    }
    &.redLevel1 .rangeSelect-el-line {
      background-color: #931919;
      border-color: #931919;
      box-shadow: 0 0 7px #931919;
    }
    &.redLevel2 .rangeSelect-el-line {
      background-color: #b72020;
      border-color: #b72020;
      box-shadow: 0 0 7px #b72020;
    }
    &.redLevel3 .rangeSelect-el-line {
      background-color: #dc2626;
      border-color: #dc2626;
      box-shadow: 0 0 7px #dc2626;
    }
    &.greenLevel1 .rangeSelect-el-line {
      background-color: #17833f;
      border-color: #17833f;
      box-shadow: 0 0 7px #17833f;
    }
    &.greenLevel2 .rangeSelect-el-line {
      background-color: #1ca44e;
      border-color: #1ca44e;
      box-shadow: 0 0 7px #1ca44e;
    }
    &.greenLevel3 .rangeSelect-el-line {
      background-color: #22c55e;
      border-color: #22c55e;
      box-shadow: 0 0 7px #22c55e;
    }

    &-circle {
      border: 3px solid #fff;
      width: 16px;
      pointer-events: none;
      border-radius: 50%;
      background: var(--color);
      position: absolute;
      top: 14px;
      height: 16px;
      transition: left 0.3s ease-in-out;
      z-index: 1;
      box-shadow: 0 0 7px #fff;
    }

    &-txt {
      text-align: center;
      margin-top: 4px;
      font-size: 12px;
      color: #a1a1aa;
      transition: 0.2s;
    }

    &:nth-child(1) {
      .rangeSelect-el-line {
        border-radius: 40px 0 0 40px;
        border-left: none;
      }
    }

    &:last-child {
      .rangeSelect-el-line {
        border-radius: 0 40px 40px 0;
      }
    }

    &-line {
      background: #464648;
      border: 2px solid #464648;
      height: 10px;
      position: relative;
      z-index: 0;
      transition: 0.15s;
    }

    &.selected {
      .rangeSelect-el-line {
        box-shadow: 0 0 7px var(--colorSelected);
        background: var(--colorSelected);
        border: 2px solid var(--colorSelected);
      }
    }

    &.active {
      .rangeSelect-el-line {
        background: var(--color);
      }
    }
  }
}
</style>
